export const enum AuthMetrics {
    SIGNIN = 'auth.signin',
};